module.exports = __webpack_public_path__ + "img/rotate-exclamation.7daf6536.svg";